import { useEffect, useMemo, useState } from "react";
import { Option } from "../../../types/types";
import useApi from "../useApi";
import webservice_url from "../../webservice/Webservice_url";
import { toast } from "react-toastify";

interface dataTypes {
    org_id: string;
    name: string;
    user_id: string;
}

export function useOrganizations() {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>(webservice_url.getOrganizationsByUserID, {
        method: "GET",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.name,
            value: d?.org_id ?? "",
        }))
    }, [dataList])
    
    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi();
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            console.error(err)
            setDataList([]);
        }
    }

    useEffect(() => {
        fetchData()
    }, [])
    

    return { dataList, options, loading };
}